import { render } from "./AssetsTable.vue?vue&type=template&id=e5cf9a56&scoped=true"
import script from "./AssetsTable.vue?vue&type=script&lang=js"
export * from "./AssetsTable.vue?vue&type=script&lang=js"

import "./AssetsTable.vue?vue&type=style&index=0&id=e5cf9a56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5cf9a56"]])

export default __exports__